/* eslint-disable no-lone-blocks */

import React, { useEffect, useState } from 'react'
import '../../Components/Barbar/styles.css'
import axios from 'axios'
import { toast } from 'react-toastify'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import Header from '../../Components/Header/page'
import Footer from '../../Components/Footer/Footer'
import { Oval } from 'react-loader-spinner'

const Login = () => {

    const naviagte = useNavigate()
    const location = useLocation();
    const params = useParams();


    console.log("naviagte:", naviagte, "location:", location, "params:", params)

    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [previousPath, setPreviousPath] = useState("")
    const [Loader, setLoader] = useState(false)

    const login = () => {
        try {
            setLoader(true)
            const data = new FormData();
            data.append('type', 'user')
            data.append('email', email)
            data.append('password', password)

            axios.post(`https://api.kazbarber.com/api/login`, data)
                .then((response) => {
                    console.log(response, "barbar")
                    if (response?.data?.status) {
                        setLoader(false)
                        localStorage.setItem('token', response?.data?.data?.access_token)
                        localStorage.setItem('role', response?.data?.data?.role)
                        toast.success('sign In Successfully', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                        // naviagte(-2)
                        {
                            previousPath === "/signup" ?
                                naviagte(-3)
                                :
                                naviagte(-1)
                        }
                    } else {
                        setLoader(false)
                        toast.error(response?.data?.error, {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    }
                }).catch((error) => {
                    setLoader(false)
                    toast.error('Something went wrong', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                })

        } catch (error) {
            setLoader(false)
            console.log(error)
            toast.success('something went wrong', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    }

    useEffect(() => {
        // Get the previous path when the component mounts
        const previousPath = location.state && location.state.from;

        setPreviousPath(previousPath);
    }, [location]);

    return (
        <>
            <Header />
            <section className='signup'>
                <div className='wrapper'>
                    <h1 className='text-light'>Sign In</h1>

                    <div className="">
                        <input type="text" className='input' placeholder="Email" onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <div className="">
                        <input type="password" className='input' placeholder="Password" onChange={(e) => setPassword(e.target.value)} />
                    </div>
                    <button type="submit" className="btn-sign" onClick={login}>
                        {Loader ?
                            <Oval
                                ariaLabel="loading-indicator"
                                height={50}
                                width={50}
                                strokeWidth={1}
                                strokeWidthSecondary={2000}
                                color="black"
                                secondaryColor="black"
                                wrapperStyle={{ display: 'flex', justifyContent: "center" }}
                            />
                            :
                            "Login"
                        }
                    </button>
                    <p className='text-light'> If you don't have an account?
                        <Link to="/signup">Sign Up</Link>
                    </p>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default Login